import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import IssueList from './proposal/List';
import IssueCreate from './proposal/Create';
import IssueDetail from './proposal/Detail';

const defaultFields = {
    Subject: { visible: false, label: '', required: false },
    Type: { visible: false, label: '', required: false },
    TaskOrder: { visible: false, label: '', required: false },
    ProjectOrder: { visible: false, label: '', required: false },
    CostEffect: { visible: false, label: '', required: false },
    DaysEffect: { visible: false, label: '', required: false },
    Details: { visible: false, label: '', required: false },
}

const defaultReplyFields = {
    ReplyStatus: { visible: false, label: '', required: false },
    ReplyComment: { visible: false, label: '', required: false },
}


///ALL FIELDS ARE DECIDED WITHIN THE getFields FUNCTION
///THE getFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign fields to workflowItem
export const getFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid, globalResources, contract) => {
    const fields = { ...defaultFields };
    const workflowItem = workflowsQA[wfid];
    let clauses = workflowItem.clauses;
    if (!clauses && placeholdersQA.ProposalClauses) {
        clauses = placeholdersQA.ProposalClauses.values.filter(item => item.isActive === true);
    }

    fields.Subject = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.SUBJECT"], required: true };
    fields.Type = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.ITEM_TYPE"].replace("{ITEM_NAME}", workflowItem.notificationName), required: true };
    fields.Type.clauses = clauses;


    if (placeholdersQA.TaskOrderOptionEnabled) {
        const toEnabled = placeholdersQA.TaskOrderOptionEnabled?.values
            .find(phItem => phItem.field === 'TaskOrderOptionEnabled').isActive;

        fields.TaskOrder = {
            visible: toEnabled,
            label: languageFile["CONTRACT.WF.COMPENSATION.FIELD.TASK_ORDER"].replace("{TASK_ORDER}",(workflowsQA['38'] || {}).notificationName),
            required: false
        };
    }

    if (placeholdersQA.ProjectOrderOptionEnabled) {
        const poEnabled = placeholdersQA.ProjectOrderOptionEnabled?.values
            .find(phItem => phItem.field === 'ProjectOrderOptionEnabled').isActive;

        fields.ProjectOrder = {
            visible: poEnabled,
            label: languageFile["CONTRACT.WF.COMPENSATION.FIELD.PROJECT_ORDER"].replace("{PROJECT_ORDER}",(workflowsQA['72'] || {}).notificationName),
            required: false
        };
    }
    if (contract?.ispackaged !== true && resources.CostEffectLabel) {
        fields.CostEffect = { visible: true, label: resources.CostEffectLabel, required: true };
    }
    if (resources.DaysEffectLabel) {
        fields.DaysEffect = { visible: true, label: resources.DaysEffectLabel, required: true };
    }
    fields.Details = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.DETAILS"], required: true };
    
    return fields;
}

///ALL REPLY FIELDS ARE DECIDED WITHIN THE getReplyFields FUNCTION
///THE getReplyFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign replyFields to workflowItem
export const getReplyFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid) => {
    const replyFields = { ...defaultReplyFields };
    const workflowItem = workflowsQA[wfid];

    let replyOptions = workflowItem.replyOptions;
    if (!replyOptions && placeholdersQA.ReplyOptions) {
        replyOptions = placeholdersQA.ReplyOptions.values.filter(item => item.isActive === true);
    }

    replyFields.ReplyStatus = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.STATUS"], required: true };
    replyFields.ReplyStatus.replyOptions = replyOptions;
    replyFields.ReplyComment = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.COMMENTS"], required: true };
    return replyFields;
}

class IssueRouter extends React.Component {
    constructor(props) {
        super(props);

        this.replyOptions = props.workflowItem.replyOptions;
        if (!this.replyOptions && props.placeholdersQA.ReplyOptions) {
            this.replyOptions = props.placeholdersQA.ReplyOptions.values.filter(item => item.isActive === true);
        }

        this.documentType = 'DocumentPrpCon';
        this.notifyingParty = props.workflowItem.notifyingParty;
        this.replyingParty = props.workflowItem.replyingParty;

        this.notificationName = props.workflowItem.notificationName;
        this.abbreviation = props.workflowItem.abbreviation;
        this.replyPeriod = props.workflowItem.replyPeriod;

    }
    shouldComponentUpdate() {
        return false;
    }
    render() {
        const { workflowItem } = this.props;

        return (
            <Routes caseSensitive>
                <Route
                    path={workflowItem.config.paths.list}
                    exact
                    element={<IssueList
                        {...this.props}
                        replyOptions={this.replyOptions}
                        title={this.notificationName}
                        abbreviation={this.abbreviation}
                    />}
                />
                <Route
                    path={workflowItem.config.paths.create}
                    exact
                    element={
                        workflowItem.userFilters.mainNotice.createAllowed ? (
                            <IssueCreate
                                {...this.props}
                                title={this.notificationName}
                            />) : (
                            <Navigate replace to={workflowItem.paths.defaultPath} />
                        )
                    }
                />
                <Route
                    path={'/:notificationid/*'}
                    exact
                    element={<IssueDetail
                        {...this.props}
                        replyOptions={this.replyOptions}
                        replyPeriod={this.replyPeriod}
                        title={this.notificationName}
                        abbreviation={this.abbreviation}
                        documentType={this.documentType}
                        notifyUserFilter={workflowItem.notifyUserFilter}
                    />}
                />
            </Routes>
        );
    }
};



export default (IssueRouter);